// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UpzX","clinicsSelect":"styles_clinicsSelect__381bW"};